import { useParams } from 'react-router-dom';
import { useEmbedDashboard } from './hooks/useDashboards';
import DashboardGrid from './components/DashboardGrid';
import type { BiWidget } from '../../types/bi';
import styles from './EmbedDashboardPage.module.css';

/**
 * Standalone embedded dashboard page — no app chrome (header/sidebar).
 * Accessed via /bi/embed/:token. Read-only, locked filters.
 */
export default function EmbedDashboardPage() {
  const { token } = useParams<{ token: string }>();
  const { data, isLoading, isError, error } = useEmbedDashboard(token);

  if (isLoading) {
    return <div className={styles.embedLoading}>Loading dashboard…</div>;
  }

  if (isError || !data) {
    const msg =
      (error as { response?: { data?: { error?: string } } })?.response?.data?.error ||
      'Unable to load this dashboard';
    return (
      <div className={styles.embedError}>
        <h2>Embed unavailable</h2>
        <p>{msg}</p>
      </div>
    );
  }

  const widgets = (data.widgets || []) as BiWidget[];

  return (
    <div className={styles.embedPage}>
      <div className={styles.embedHeader}>
        <h1 className={styles.embedTitle}>{data.name}</h1>
        <span className={styles.embedBranding}>Powered by Junior BI</span>
      </div>

      {widgets.length > 0 ? (
        <DashboardGrid
          widgets={widgets}
          dateRange={null}
          onSavePositions={() => {}}
          onConfigureWidget={() => {}}
          onRemoveWidget={() => {}}
          readOnly
        />
      ) : (
        <div className={styles.embedLoading}>This dashboard has no widgets.</div>
      )}
    </div>
  );
}
